var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "" } },
            [
              _c("div", { staticClass: "text-md-center" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.version) + " [" + _vm._s(_vm.gitBranch) + "]"
                  )
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v(_vm._s(_vm.errorCode))]),
                _vm._v(" "),
                _c("h3", { staticClass: "my-3 headline" }, [
                  _vm._v(_vm._s(_vm.errorMessage))
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "my-3 headline" }, [
                  _vm._v(_vm._s(_vm.errorStack))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v(
                      "\n          En cas de persistence de l'erreur, merci d'appuyer sur ce bouton :\n          "
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-2",
                        attrs: { small: "" },
                        on: { click: _vm.resetPreferences }
                      },
                      [
                        _vm._v(
                          "\n            Réinitialiser mes préférences\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }